<template lang="pug">
.py-24.px-50.text-left
  .flex.items-center.justify-between.relative()
    .flex.items-center  
      .rounded-4.border.border-black.w-20.h-20.items-center.flex.justify-center.mr-10.cursor-pointer( @click="changeConfigStatus")
        .rounded-2.border.w-10.h-10.bg-main-0(v-if="allConfig==1")
        .bg-main-0.w-10.h-2(v-if="allConfig==2")
      .w-57(v-if="this.tablecheck.length==0") {{$t('__e5H7.__allConfig')}}   
      .flex.items-center.cursor-pointer.text-main-0(v-if="this.tablecheck.length>0" @click="openDeletePopup(false)" class="hover:text-black")  
        iCon.h-24.w-24(:iconClass="'Ico_Delete'" type="svg" )
        .w-57.ml-8.mt-4 {{$t('__e5H7.__delete')}}
    .flex.items-center.cursor-pointer.text-main-0(@click.stop="showFilter" class="hover:text-black")  
      iCon.h-24.w-24(:iconClass="'Ico_Filter'" type="svg" )
      .ml-8 {{$t('__e5H7._filter')}}
    .absolute.top-24.right-0.z-350.w-160.shadow-user( v-if="infoIsShow" v-click-outside="outsideHandler")  
      .bg-white.shadow-lg.rounded-4.overflow-hidden.text-black.py-14(v-if="showFilterIcon")
        .px-14.py-2.flex.justify-between.items-center.text-left.cursor-pointer(
          v-for="(item, index) in rangeDayOption"
          class="active:text-main-0  hover:text-main-0 " @click="selectFrequency(item)"
          ) 
          .text-14.leading-24(
            ) {{item.name}} 
          iCon.h-24.w-24.inline-block.-grey-e6(iconClass="check" type="svg" v-if="rangeTypeSelect.id == item.id")
  //- Select.w-220(
  //-   :defaultSelectedValue="rangeDay" 
  //-   :optionArr="rangeDayOption" 
  //-   :isSearch="false"
  //-   @onClick="selectFrequency"
  //-   @onblur="toblur" 
  //-   name="frequency")
  .mt-40
    TableBar(:mainData="tableData" v-if="tableData.length" @openExport="openExport" @openDelete="openTableDelete" @getDeleteConfigList="getDeleteConfigList" :allConfigId="allConfigId" :allConfig="allConfig").flex.flex-wrap.ml-22
      template(#second="{ dataIndex, data ,item}" )
        //- .bg-grey-cc.w-full.h-px.mt-8
        //- .py-28.px-36.relative
        //-   .flex(v-for="(e ,i) in historyColumn" :class="{'mt-24': i > 0 , 'mb-24': i < historyColumn.length-1}")
        //-     .min-w-200.font-600 {{e.title}}  ???
        //-     .ml-14.text-grey-op05(v-if="typeOfObj(data[e.key])")
        //-       span {{resultListItem(data[e.key],e.key)}} 2222
        //-     .ml-14.text-grey-op05(v-else) 
        //-       span {{resultListItem(data[e.key],e.key)}}  
        //-     .absolute.text-main-0.top-28.right-36.flex.items-center.justify-center.cursor-pointer(@click="openExport(item)")
        //-       iCon.h-24.w-24(:iconClass="'ico_Launch'" type="svg" )
    .mb-115(v-if="!tableData.length && localLoading")
      .w-144.h-144.m-auto
        img.w-full( src='@/assets/Default.png')
      //- .mt-40.w-full.text-center.m-auto.text-16(v-html="$xss($t('__e5H7.__loadingText'))") 
      .mt-40.w-full.text-center.m-auto.text-16 
        span {{handleI18nString(0)}} 
        span.link.cursor-pointer.text-main-0(@click="goToNewConfig") {{handleI18nString(1)}} 
        span {{handleI18nString(2)}}
    .mb-115(v-if="errorList ")
      .w-144.h-144.m-auto
        img.w-full( src='@/assets/Default.png')
      .mt-40.w-240.text-center.m-auto.text-16.font-600.text-grey-9E {{$t('__e5H7.__errorText')}}
    Pagination.mt-56(
      v-if="tableData.length"
      :totalPage="meta.total_page" 
      :nowPage="meta.current" 
      :range="range" 
      @changePage="changePage" 
      position="center")
    Modal.z-600(
      :show="exportModal" 
      :clickOutSideClose="false" 
      @closeModal="exportClose" 
      :header="'header'"
      :body="'footerBody'" 
      footer="footer"  
      )
      template(#header)
        .text-left.text-18.text-main-0.font-600.mt-22 {{$t('__e5H7.__export')}} 
      template(#footerBody)
        .mt-24.w-420.m-auto
          .row.my-20
            label.font-500.min-w-200.inline-block.text-16.mr-16
              span {{$t('__e5H7.__pleaseNameForYourFile')}}
            .w-full.mt-36
              Input.mr-10.w-420(type="text" @onKey="versionValid" :maxLength="'50'" :error="errorFileName" v-model="fileName" :placeholder="'Please input File name here'" )
      template(#footer)
        .flex.justify-center.mt-56
          Button.w-140.mr-20(:text="$t('__globeButton.__cancel')" type="borderSolid"  @buttonClick='exportClose()')
          Button.w-140(:text="$t('__globeButton.__export')"  type="normal"  @buttonClick='exportFile()')
    Modal.z-600(
      :show="deleteModal" 
      :clickOutSideClose="false" 
      @closeModal="deleteClose" 
      :header="'header'"
      :body="'footerBody'" 
      footer="footer"  
      )
      template(#header)
        .text-center.text-18.text-main-0.font-600.mt-22 {{$t('__e5H7.__deleteSelectedConfig')}} 
      template(#footerBody)
        .mt-24.w-420.m-auto.text-center
          .row.my-20
            label.font-500.min-w-200.inline-block.text-16.mr-16
              span {{$t('__e5H7.__yourConfigWillBePermanentlyDeleted')}}
      template(#footer)
        .flex.justify-center.mt-56
          Button.w-140.mr-20(:text="$t('__globeButton.__cancel')" type="borderSolid"  @buttonClick='deleteClose()')
          Button.w-140(:text="$t('__e5H7.__delete')"  type="normal"  @buttonClick='deleteFile()')
    Toast(:show.sync="toast" :text="$t('__common.__success')")
</template>

<script>
import moment from "moment";

import { ENV, WEEKSTRING } from "@/enum/global";
import { encodeHTML } from "@/utils/xxsConfig.js";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import Select from "@/components/Select.vue";
import TableBar from "@/components/TableBar.vue";
import TableEach from "@/components/TableEach.vue";
import Pagination from "@/components/Pagination.vue";
import Modal from "@/components/Modal.vue";
import Toast from "@/components/Toast.vue";
import Checkbox from "@/components/Checkbox.vue";

import {
  configurationList,
  configurationDelete,
  configurationDeleteList
} from "@/api/configuration.js";

import { exportHistory } from "@/api/export.js";
import { dynamicLink } from "@/api/users.js";
import { axiosDefaultsURL } from "@/api/axios";
import { PAGEINDEX } from "@/enum/global";

export default {
  name: "ExportHistory",
  components: {
    Button,
    Input,
    Select,
    TableBar,
    TableEach,
    Pagination,
    Modal,
    Toast,
    Checkbox
  },
  data() {
    return {
      toast: false,
      localLoading: false,
      meta: {
        //Pagination data
        current: 1,
        total: 0,
        total_page: 0,
        page_size: 16
      },
      apiError: null, //個別頁面的api error handler
      rangeDay: undefined,
      tableData: [],
      allConfigId: [],
      exportItem: {},
      exportModal: false,
      errorFileName: "",
      fileName: "",
      startDay: "",
      errorList: false,
      allConfig: 0,
      deleteModal: false,
      deleteItem: {},
      infoIsShow: true,
      showFilterIcon: false,
      rangeTypeSelect: { id: "1", name: this.$t("__e5H7.__30"), i18n: "__e5H7.__30" },
      tablecheck: [],
      isSingleDelete: false
    };
  },
  async created() {
    await this.$store.dispatch("common/getDropDownList");
  },
  async mounted() {
    this.rangeDay = this.rangeDayOption[0];
  },
  methods: {
    goToNewConfig() {
      this.$router.push("createnew");
    },
    handleI18nString(num) {
      let mutiLang = this.$t("__e5H7.__loadingText").split("///");
      return mutiLang[num];
    },
    changeConfigStatus() {
      //都沒選
      if (this.allConfig == 0) {
        this.allConfig = 1;
        //全選
      } else if (this.allConfig == 1) {
        this.allConfig = 0;
        //部分選
      } else if (this.allConfig == 2) {
        this.allConfig = 0;
      }
    },
    getDeleteConfigList(item) {
      this.tablecheck = item;
    },
    outsideHandler() {
      this.showFilterIcon = false;
    },
    showFilter() {
      // this.closeAll();
      this.showFilterIcon = true;
    },
    async getConfigurationList() {
      let today = new Date();
      let sendData = {
        page_size: this.meta.page_size,
        page: this.meta.current,
        created_after: moment(this.startDay).toISOString(),
        created_before: moment(today).toISOString()
      };
      try {
        const { data } = await configurationList(sendData);
        if (data) {
          this.errorList = false;
          if (data.results.length > 0) {
            let temp = [];
            for (let i = 0; i < data.results.length; i++) {
              data.results[i].severity = data.results[i].severity.reverse();
              let time = moment(
                data.results[i].created_time.replace(/ /g, ""),
                moment.ISO_8601
              ).format("YYYY/MM/DD A HH:mm");
              let dayString = "";
              let timeString = "";
              if (data.results[i]["auto_check_frequency"] == "Monthly") {
                dayString = data.results[i]["day"];
                timeString = moment(data.results[i]["time"], "HH:mm:ss").format("HH:mm");
              } else if (data.results[i]["auto_check_frequency"] == "Weekly") {
                dayString = WEEKSTRING[data.results[i]["day"]];
                timeString = moment(data.results[i]["time"], "HH:mm:ss").format("HH:mm");
              }
              let frequency = [data.results[i]["auto_check_frequency"], dayString, timeString];
              let location = Intl.DateTimeFormat().resolvedOptions().timeZone;
              let timeZoneDefault = Intl.DateTimeFormat("fr", {
                timeZoneName: "short",
                timeZone: location
              })
                .formatToParts()
                .find(i => i.type === "timeZoneName").value;
              temp.push({
                name: time + "     (" + timeZoneDefault + ")",
                id: data.results[i].id,
                data: { frequency: frequency, ...data.results[i] },
                val: data.results[i].id,
                disabled: false
              });
            }
            this.tableData = temp;
            //迴圈取出所有資料id
            let tempId = [];
            for (let i = 0; i < data.results.length; i++) {
              tempId.push(data.results[i].id);
            }
            this.allConfigId = tempId;
          } else {
            this.localLoading = true;
            this.tableData = [];
          }
          this.meta.total = data.count;
          this.meta.total_page = Math.ceil(data.count / this.meta.page_size);
          this.meta.current = data.current;
        }
        this.tablecheck = [];
        this.allConfig = 0;
      } catch (error) {
        this.errorList = true;
        this.tablecheck = [];
        // this.apiError = error.response.status;
      }
    },
    typeOfObj(e) {
      if (typeof e != "object") {
        return true;
      } else {
        return false;
      }
    },
    changeStep(e) {
      this.currentStep = e.index;
    },
    selectFrequency(e) {
      this.meta.current = 1;
      this.rangeDay = e;
      this.rangeTypeSelect = e;
    },
    toblur() {},
    async changePage(page) {
      this.meta.current = page;
      this.getConfigurationList()
      
    },
    openExport(e) {
      this.fileName = e.data.filename;
      this.exportItem = e;
      this.exportModal = true;
    },
    exportClose() {
      this.exportItem = {};
      this.exportModal = false;
      this.errorFileName = "";
    },
    //打開單個的delete
    openTableDelete(e) {
      //整理成單個delete要的格式
      this.deleteItem = { id: e.val };
      this.openDeletePopup(true);
    },
    openDeletePopup(flag) {
      this.isSingleDelete = flag ? true : false;
      this.deleteModal = true;
    },
    deleteClose() {
      this.deleteItem = {};
      this.deleteModal = false;
      this.errorFileName = "";
    },
    async deleteFile() {
      let sendData = this.isSingleDelete
        ? this.deleteItem
        : {
            config_id: this.tablecheck
          };
      if (this.isSingleDelete) {
        try {
          await configurationDelete(sendData);
          await this.getConfigurationList();
          this.deleteClose();
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          await configurationDeleteList(sendData);
          await this.getConfigurationList();

          this.deleteClose();
        } catch (error) {
          console.log(error);
        }
      }
    },
    async exportFile() {
      let filename = this.fileName;
      let id = this.exportItem.id.toString();
      const sendData = {
        filename: filename
      };
      try {
        const { data } = await exportHistory(id, sendData);
        this.downloadFile(data, filename);
      } catch (error) {
        this.apiError = error.response.status;
      }
      // let filename = this.fileName;
      // let id  = this.exportItem.id.toString();
      // let localURL = `${axiosDefaultsURL}configuration/${id}/export/?filename=${filename}`
      // if(process.env.VUE_APP_ENV == ENV.UAT  || process.env.VUE_APP_ENV == ENV.PRODUCTION){
      //   try{
      //     await dynamicLink(localURL);
      //     console.log('env pro link is valid?',localURL);
      //     this.downloadFile(localURL)
      //   }
      //   catch (error) {
      //     this.apiError = error.response.status;
      //     console.log('inside error')
      //   }
      // }else{
      //   console.log('env local',localURL)
      //   this.downloadFile(localURL)
      // }
      this.exportClose();
    },
    async downloadFile(blob, filename) {
      // let clean = encodeHTML(url) //安全性轉
      // window.location = clean;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.setAttribute("rel", "noopener"); //安全性問題預防
      link.href = url;
      link.setAttribute("download", `${filename}.config`); //or any other extension
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      this.toast = true;
      setTimeout(() => {
        this.$router.push({
          name: PAGEINDEX.CREATE
        });
      }, 1500);
    },
    versionValid() {
      if (this.fileName) {
        // console.log('match', !/^[A-Za-z][A-Za-z0-9]*$/.test(this.fileName) )
        if (!this.fileName.match(/^[\w\-(){}A-Za-z0-9.]+$/)) {
          this.errorFileName = this.errorValidFileName;
        } else {
          this.errorFileName = "";
        }
      }
    },
    resultListItem(item, key) {
      let useList = {
        Weekly: "__c6N3.__weekly",
        Manual: "__c6N3.__manual",
        Monthly: "__c6N3.__monthly"
      };
      let weekList = {
        Sunday: "__common.__sunday",
        Monday: "__common.__monday",
        Tuesday: "__common.__tuesday",
        Wednesday: "__common.__wednesday",
        Thursday: "__common.__thursday",
        Friday: "__common.__friday",
        Saturday: "__common.__saturday"
      };
      let severityList = {
        HIGH : '__c6N3.__urgent',
        MEDIUM : '__c6N3.__recommend',
        LOW : '__c6N3.__optional',
      }
      let temp = []
      let result = ''
      
      switch (key) {
        case "frequency":
          for (let i = 0; i < item.length; i++) {
            if (i == 0) {
              temp.push(this.$t(useList[item[i]]));
            } else if (i == 1) {
              if (item[0] == "Weekly") {
                temp.push(this.$t(weekList[item[i]]));
              } else {
                temp.push(item[i]);
              }
            } else if (i == 2) {
              temp.push(item[i]);
            }
          }
          temp = temp.filter(n => n);
          result = temp.join(", ");
          return result;
        case "update_behavior":
          if (item == "NotifyOnly") {
            return this.$t("__c6N3.__notifyOnly");
          } else {
            return this.$t("__c6N3.__downloadInstall");
          }
        case "severity":
          for (let i = 0; i < item.length; i++) {
            temp.push(this.$t(severityList[item[i]]));
          }
          temp = temp.filter(n => n)
          result = temp.join(', ')
          return result
        case 'category':
          result = item.join(', ')
          return result
        default:
          break;
      }
    }
  },
  watch: {
    "$store.state.user.user": function() {},
    rangeDay: {
      handler: function(n) {
        let today = new Date();
        let a = moment(today).subtract(30, "day");
        switch (n.id) {
          case "1":
            this.startDay = moment(today).subtract(30, "Day");
            break;
          case "2":
            this.startDay = moment(today).subtract(90, "Day");
            break;
          case "3":
            this.startDay = moment(today).subtract(1, "Year");
            break;
        }
      },
      deep: true
    },
    startDay: {
      handler: async function() {
        await this.getConfigurationList();
      },
      deep: true
    },
    tablecheck: {
      handler: function() {
        if (this.tablecheck.length == this.tableData.length) {
          this.allConfig = 1; //全選
        } else if (this.tablecheck.length == 0) {
          this.allConfig = 0; //都沒選
        } else if (this.tablecheck.length < this.tableData.length) {
          this.allConfig = 2; //部分選
        }
      }
    },
    allConfig: {
      handler: function() {
        if (this.allConfig == 1) {
          this.tablecheck = this.allConfigId;
          this.getDeleteConfigList(this.tablecheck);
        } else if (this.allConfig == 0) {
          this.tablecheck = [];
        }
      }
    }
  },
  computed: {
    rangeDayOption() {
      return [
        { id: "1", name: this.$t("__e5H7.__30"), i18n: "__e5H7.__30" },
        { id: "2", name: this.$t("__e5H7.__90"), i18n: "__e5H7.__90" },
        { id: "3", name: this.$t("__e5H7.__1"), i18n: "__e5H7.__1" }
      ];
    },
    severityList() {
      let temp = [];
      if (this.$store.state.common.severity) {
        temp = [
          {
            name: this.$t("__c6N3.__urgent"),
            val: this.$store.state.common.severity[2],
            disabled: true
          },
          {
            name: this.$t("__c6N3.__recommend"),
            val: this.$store.state.common.severity[1],
            disabled: false
          },
          {
            name: this.$t("__c6N3.__optional"),
            val: this.$store.state.common.severity[0],
            disabled: false
          }
        ];
      }
      return temp;
    },
    errorValidFileName() {
      let text = `${this.$t("__c6N3.__thisIsNotAValidFileName")}<br>
      ${this.$t("__c6N3.__pleaseMakeSureTheFileName")} <br>
      ${this.$t("__c6N3.__theFileNameOnlyAllows")} <br>
      ${this.$t("__c6N3.__theFileNameCannotContain")}<br>
      ${this.$t("__c6N3.__theFileNameShouldNotBeFullWidthText")}`;
      return text;
    },
    historyColumn() {
      //driver packs 的欄位title
      return [
        {
          title: this.$t("__c6N3.__frequency"),
          key: "frequency"
        },
        {
          title: this.$t("__c6N3.__updateBehavior"),
          key: "update_behavior"
        },
        {
          title: this.$t("__c6N3.__severity"),
          key: "severity"
        },
        {
          title: this.$t("__c6N3.__category"),
          key: "category"
        }
      ];
    },
    range() {
      return this.meta.total_page < 5 ? this.meta.total_page : 5;
    }
  }
};
</script>

<style lang="scss" scoped></style>
